import React, { useContext } from "react";
import { AuthContext } from "../../../context/authcontext";
import { useTenantRole } from "../../../components/TenantRoleDisplay";
import OldDashboard from "./oldDashboard";
import NewDashboard from "./dashboard";
import SalesUserDashboard from "./salesUserDashboard";

const CLIENT_ADMIN_ROLES = ["CLIENTADMIN"];
const SALES_USER_ROLES = ["SALESUSER"];
const PLATFORM_ROLES = ["SUPERADMIN", "PLATFORMANALYST", "APIADMIN"];

const normalizeRole = (role: unknown) => String(role ?? "").toUpperCase().replace(/[\s_]/g, "");

const RoleBasedDashboard = () => {
  const { auth, selectedTenantId } = useContext(AuthContext);
  const role = useTenantRole(selectedTenantId || "");
  const roleKey = normalizeRole(role?.role_key || role?.role_name);

  if (CLIENT_ADMIN_ROLES.includes(roleKey)) return <NewDashboard />;
  if (SALES_USER_ROLES.includes(roleKey)) return <SalesUserDashboard />;

  const isPlatformUser = (auth?.tenants ?? []).some((tenant: any) =>
    [tenant?.role_key, tenant?.role_name].some((value) => PLATFORM_ROLES.includes(normalizeRole(value)))
  );
  if (role || isPlatformUser) return <OldDashboard />;

  return (
    <div className="page-wrapper">
      <div className="content d-flex align-items-center justify-content-center" style={{ minHeight: 320 }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading dashboard</span>
        </div>
      </div>
    </div>
  );
};

export default RoleBasedDashboard;
